import { render, staticRenderFns } from "./PayWithWagestreamAccount.vue?vue&type=template&id=3453130d&scoped=true&"
import script from "./PayWithWagestreamAccount.vue?vue&type=script&lang=js&"
export * from "./PayWithWagestreamAccount.vue?vue&type=script&lang=js&"
import style0 from "./PayWithWagestreamAccount.vue?vue&type=style&index=0&id=3453130d&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3453130d",
  null
  
)

export default component.exports